import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import toolbar from "./toolbar";
import { useEffect, useCallback } from "react";
import Quill from "quill";

const Parchment = Quill.import("parchment");
const ListColor = new Parchment.Attributor.Style("list-color", "color", {
  scope: Parchment.Scope.BLOCK,
});
Quill.register(ListColor, true);

const Size = Quill.import('attributors/style/size');
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px'];

Quill.register(Size, true);

function QuillComponent({ text, onQuillData }) {
  const { quill, quillRef } = useQuill({
    modules: {
      toolbar: toolbar,
    },
  });

  const paintBullets = useCallback(() => {
    if (!quill) return;

    const listItems = quill.root.querySelectorAll("li");

    listItems.forEach((li) => {
      const coloredChild = li.querySelector('[style*="color"]');

      if (!li.style.color && coloredChild && coloredChild.style.color) {
        li.style.color = coloredChild.style.color;
      }
      else if (
        coloredChild &&
        coloredChild.style.color &&
        li.style.color !== coloredChild.style.color
      ) {
        li.style.color = coloredChild.style.color;
      }
      else if (!coloredChild && li.style.color) {
        li.style.color = "";
      }
    });
  }, [quill]);

  useEffect(() => {
    if (!quill) return;

    if (text) {
      quill.setContents(JSON.parse(text));
      setTimeout(paintBullets, 50);
    }

    quill.on("editor-change", paintBullets);

    return () => {
      quill.off("editor-change", paintBullets);
    };
  }, [quill, text, paintBullets]);

  const handleSubmit = (event) => {
    event.preventDefault();

    paintBullets();

    const rawContent = quill.getContents();

    const fixedOps = rawContent.ops.map((op, index, array) => {
      if (op.insert === "\n" && op.attributes && op.attributes.list) {
        const prevOp = array[index - 1];
        const color = prevOp?.attributes?.color;

        if (color) {
          return {
            ...op,
            attributes: {
              ...op.attributes,
              "list-color": color,
              color: undefined,
            },
          };
        }
      }
      return op;
    });

    const cleanContent = { ops: fixedOps };

    if (onQuillData) {
      onQuillData({
        content: JSON.stringify(cleanContent),
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="editor">
        <div ref={quillRef}></div>
      </div>
      <button type="submit">Guardar</button>
    </form>
  );
}

export default QuillComponent;
